// extracted by mini-css-extract-plugin
export default {"faqMedia":"FaqMediaContent_faqMedia__kL651","title":"FaqMediaContent_title__Sl9PX"};